
import ISearch from './ISearch/ISearch';
import Popup from 'vux/src/components/popup/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import {HotelSearchProxy} from "@/http/RequestProxy.class";

const hotelSearchProxy = new HotelSearchProxy();

export default {
name: 'search-hotel',
components: {
ISearch,
Popup,
Group,
Cell,
},
props: {
isShow: {
type: Boolean,
default: false,
},
},
data(){
return {
isShowSearchResult: false,
isNoResult: true,
isShowHotCity: true,
gridData: [],
columnList: [],
searchResult: [],
keyword: '',

localSearchData: [],  // 酒店搜索历史数据
};
},

mounted(){
this.getLocalHotelSearch();
},

methods: {
/** 获取推荐地区列表数据 */
getHotCityData(){
this.$vux.loading.show({
text: this.$i18n.t('hotel.LOADING'),
});

hotelSearchProxy.getHotRegion({language: 1})
.then(resp => {
if(resp){
this.gridData = resp.data.grid_list;
this.columnList = resp.data.column_list;
}
this.$vux.loading.hide();
});
},

/** 显示搜索组件 */
onShowPopup(){
if(this.gridData.length == 0 || this.columnList.length == 0){
this.getHotCityData();
}
},

/** 隐藏搜索组件 */
onCancelSearch(){
this.isShowHotCity = true;
this.isNoResult = true;
this.isShowSearchResult = false;

this.$emit('on-hide', false);
},

/** 隐藏推荐地区列表 */
onFocus(){
this.isShowHotCity = false;
this.isShowSearchResult = true;

if(this.searchResult.length == 0){
this.isNoResult = true;
}else{
this.isNoResult = false;
}
},

/** 热门城市选择 */
onSelectHotRegion(event, layoutName = ''){
const dataset = layoutName === 'list_layout' ? event.currentTarget.dataset : event.target.dataset;


const localHash = {
id: dataset.regionId,
name: dataset.regionName,
type: 'region',
};

this._saveSearch2Local(localHash);   

this.onCancelSearch();
this.$emit('on-select', {region_id: dataset.regionId, name: dataset.regionName, hotel_id: '', location: ''});
},

/** 搜索地区或酒店 */
onSearch(keyword){
this.keyword = keyword;

hotelSearchProxy.searchRegionOrHotel({keyword})
.then(resp => {
if(resp){
this.searchResult = resp.data.place;

if(resp.data.place.length == 0){
this.isNoResult = true;
}else{
this.isNoResult = false;
}
}
});
},

/** 选择搜索的地区或酒店 */
onSelectSearch(ev, placeType, placeId, placeName, unSave2Local){
const params = {
name: placeName,
};

if(placeType === 'region'){           // 地区搜索
params['hotel_id'] = '';
params['region_id'] = placeId;
params['place_id'] = '';
}else if(placeType === 'hotel'){      // 酒店名称搜索
params['hotel_id'] = placeId;
params['region_id'] = '';
params['place_id'] = '';
}else if(placeType === 'landmark'){   // 地标搜索
params['hotel_id'] = '';
params['region_id'] = '';
params['place_id'] = placeId;
}else{        // 附近酒店搜索
params['hotel_id'] = '';
params['region_id'] = '';
params['place_id'] = '';

this.searchNearby(params);
return false;
}


if(placeType !== 'nearby' && !unSave2Local){
const localHash = {
id: placeId,
name: placeName,
type: placeType,
};

this._saveSearch2Local(localHash);   
}

this.onCancelSearch();
this.isShowSearchResult = false;
this.$emit('on-select', params);
},

_saveSearch2Local(resource){
const originRes = window.localStorage.getItem('hotel_search');
const result =  originRes ? JSON.parse(originRes) : [];

if(result.length === 0){
result.push(resource);
}else{
let unSaved = true;

result.forEach(function (itm) {
if(itm.id === resource.id){
unSaved = false;
}
});

if(unSaved){
result.push(resource);
}
}

window.localStorage.setItem('hotel_search', JSON.stringify(result));
this.getLocalHotelSearch();
},

getLocalHotelSearch(){
const originRes = window.localStorage.getItem('hotel_search');
const result =  originRes ? JSON.parse(originRes) : [];

this.localSearchData = result;
},

clearLocalSearch(){
window.localStorage.removeItem('hotel_search');
this.localSearchData = [];
},

/** 搜索附近酒店 */
searchNearby(params){
if (window.navigator.geolocation) {
const options = {
enableHighAccuracy: true,
};

window.navigator.geolocation.getCurrentPosition(() => {
this._getGeoSuccess(params);
}, this._getGeoError, options);
} else {
this.$vux.toast.show('No Support Geolocation!');
}
},

/** 获取定位成功 */
_getGeoSuccess(params){
let lon, lat;

window.navigator.geolocation.getCurrentPosition(position => {
lon = position.coords.longitude;
lat = position.coords.latitude;



params.location = `${lat},${lon},5000`;
this.onCancelSearch();
this.isShowSearchResult = false;
this.$emit('on-select', params);
});
},

/** 获取定位失败 */
_getGeoError(error){
switch (error.code) {
case 0:
case 1:
case 2:
case 3:
this.$vux.toast.show(error.message);
break;
default: break;
}
},
},

/*filters: {
/!** 过滤搜索结果中的关键字，将关键字高亮显示 *!/
formatKeyword(result, keyword){
const reg = new RegExp(keyword);

return result.replace(reg, `<span class="font-color-blue">${keyword}</span>`);
},
},*/
}



// WEBPACK FOOTER //
// ./src/components/HotelSearch.vue